import React from 'react';
import { Link } from 'react-router-dom';

interface Channel {
  id: string;
  label: string;
  status: 'active' | 'setup' | 'inactive';
  path: string;
}

interface CommunicationChannelsProps {
  channels: Channel[];
  onChannelClick: (channelPath: string) => void;
}

const CommunicationChannels: React.FC<CommunicationChannelsProps> = ({
  channels,
  onChannelClick
}) => {
  const getStatusColor = (status: string) => {
    switch(status) {
      case 'active': return 'bg-green-500';
      case 'setup': return 'bg-yellow-500';
      case 'inactive': return 'bg-gray-400';
      default: return 'bg-blue-500';
    }
  };

  const getStatusIcon = (status: string) => {
    switch(status) {
      case 'active': return <span className="text-green-600">●</span>;
      case 'setup': return <span className="text-yellow-600">⚠</span>;
      case 'inactive': return <span className="text-[#7B7B7B] font-semibold">○</span>;
      default: return <span className="text-blue-600">●</span>;
    }
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-6">
      <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-6">Communication Channels</h3>
      <div className="grid grid-cols-1 gap-4">
        {channels.map((channel) => (
          <Link
            key={channel.id}
            to={channel.path}
            className="flex items-center justify-between p-4 border border-gray-200 dark:border-gray-700 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors cursor-pointer"
            onClick={() => onChannelClick(channel.path)}
          >
            <div className="flex items-center space-x-3">
              <div className={`w-3 h-3 rounded-full ${getStatusColor(channel.status)}`} />
              <div>
                <p className="font-medium text-gray-900 dark:text-gray-100">{channel.label}</p>
                <p className="text-sm text-gray-500 dark:text-gray-400 capitalize">{channel.status}</p>
              </div>
            </div>
            <div className="font-semibold">
              {getStatusIcon(channel.status)}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default CommunicationChannels;